import { mapState } from 'vuex'
import moment from 'moment/moment';

const defaultFilterValues = {
};

export default {
  name: 'SmsList',
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'created_at', direction: 'desc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      return [
        { key: 'phone', label: this.$t('menu.config.sms.phone'), filterKey: 'phone' },
        { key: 'type', label: this.$t('menu.config.sms.type'), filterKey: 'type' },
        { key: 'created_at', label: this.$t('menu.config.sms.created_at'), format: 'formatFunc', funcs: [this.formatAsDateTime] },
        { key: 'response_id', label: this.$t('menu.config.sms.response_id') }
      ];
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    tableFilterConfig () {
      const filters = { };
      filters.phone = { type: 'text', label: '', colOnlyFilter: true };
      filters.type = { type: 'text', label: '', colOnlyFilter: true };
      return filters;
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath('sms/sent-messages?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    }
  },
  methods: {
    formatAsDateTime (value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.loading = true;
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
